import React from "react";
import { IndexRoute, Route } from "react-router";
import Accurence from "shared/containers/Accurence/index";
import WorkScheduler from "shared/containers/WorkScheduler/index";
import Dashboard from "shared/containers/Dashboard/index";
import Login from "shared/containers/Login/index";
import PeriodicalConfig from "shared/containers/PeriodicalConfig/index";
import Periodicls from "shared/containers/Periodicals/index";
import PeriodicalScheduling from "shared/containers/PeriodicalScheduling/index";
import PeriodicalStatus from "shared/containers/PeriodicalStatus/index";
import AutoLogin from "../shared/containers/autoLogin/index";
import ConsolidateReport from "../shared/containers/Reports/ConsolidateReport";
import Reports from "../shared/containers/Reports/index";
import StatusViewContainer from "../shared/containers/statusView";
import App from "./App";

export default (
  <Route>
    <Route component={App} path="/">
      <IndexRoute component={Login} />
      <Route path="autologin" component={AutoLogin} />
      <Route component={WorkScheduler}>
        <Route path="dashboard" component={Dashboard} />
        <Route path="periodical_master" component={Periodicls} />
        <Route path="accurence_master" component={Accurence} />
        <Route path="periodical_configuration" component={PeriodicalConfig} />
        <Route path="periodical_scheduling" component={PeriodicalScheduling} />
        <Route path="periodical_status" component={PeriodicalStatus} />
        <Route path="status_view" component={StatusViewContainer} />
        <Route path="reports" component={Reports} />
        <Route path="periodical_status_report" component={ConsolidateReport} />
      </Route>
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/web/routes.js